
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import PropTypes, { string } from 'prop-types';
import { Button } from '@mui/material';
import { Row, Grid, Col, Panel } from "react-bootstrap";
import PopupApcode from './../../../PopUp/PopUpApcode'
import axios from 'axios'
import { gengetURLTEST, genURL } from '../../../_getjson';
import Snackbar from '../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
export default function Inputtax(props) {
    const { parm, recheckeddata, from } = props
    const [listitem, setListitem] = useState([])
    const Refundablerate = useRef(0)
    const Refundablevalue = useRef()
    const Totaltax = useRef();
    const Taxrefund = useRef();
    const [SwitchPopupApcode, setSwitchPopupApcode] = useState()
    const [WHRow1, setWHRow1] = useState("");
    const [col2, setcol2] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [icon, setIcon] = useState(ErrorIcon);
    const [color, setcolor] = useState("warning");
    const [messagealert, setmessagealert] = useState("");
    const [opensnackbar, setopensnackbar] = useState(false);

    useEffect(() => {
        componentdidmount()
        return () => {
        }
    }, [])

    useEffect(() => {

        try {
            if (recheckeddata.length > 0) {
                caltax()
            }
        } catch (error) {
            console.log("err:", error)
        }


        return () => {

        }
    }, [listitem])

    const componentdidmount = async () => {
        //console.log(" componentdidmount  recheckeddata", recheckeddata)

        if (recheckeddata.length > 0) {
            let url = `CSINPUTTAX/Search?Tablename=` + from + `&Docno=` + recheckeddata[0].DOCNO
            await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                //   console.log(" componentdidmount  res.length", res.data)
                let item = []
                let Newitem = []
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        let Taxincludeddata = res.data[i].TAXRATE
                        //    Number(res.data[i].BEFORETAX)
                        item[i] = {
                            Taxinvoice: res.data[i].TAXNO,
                            Invoicedate: res.data[i].TAXDATE,
                            PayableCode: res.data[i].APCODE,
                            PayableName: res.data[i].APNAME,
                            Taxdescription: res.data[i].REMARK,
                            Amountbeforetax: res.data[i].BEFORETAX,
                            TaxPersen: res.data[i].TAXRATE,
                            Taxincluded: res.data[i].TOTALAMOUNT,
                            Tax: res.data[i].TAXAMOUNT
                        }
                    }
                }
                setListitem(item)
            })

        } else {
            if (parm[4].length > 0) {
                // console.log("parm[4].length > 0");
                Totaltax.current.value = parseFloat(parm[8]).toFixed(2)
                Taxrefund.current.value = parseFloat(parm[7]).toFixed(2)
                Refundablevalue.current.value = parseFloat(parm[6]).toFixed(2)
                Refundablerate.current.value = parseFloat(parm[5]).toFixed(2)
                await setListitem(parm[4])
            } else {
                // console.log("parm[4].length === 0");
                Totaltax.current.value = parseFloat(0).toFixed(2)
                Taxrefund.current.value = parseFloat(0).toFixed(2)
                Refundablevalue.current.value = parseFloat(0).toFixed(2)
                Refundablerate.current.value = parseFloat(0).toFixed(2)
                let item = []
                for (let index = 0; index < 30; index++) {
                    item[index] = {
                        Taxinvoice: "",
                        Invoicedate: "",
                        PayableCode: "",
                        PayableName: '',
                        Taxdescription: "",
                        Amountbeforetax: "",
                        Tax: "",
                        Taxincluded: "",
                        Refundablerate: (0.00).toFixed(2),
                        Refundablevalue: (0.00).toFixed(2),
                        Refundabletax: (0.00).toFixed(2),
                    }
                    setListitem(item)
                }
            }
        }


    }


    function round(num, decimalPlaces = 0) {
        var p = Math.pow(10, decimalPlaces);
        var n = (num * p) * (1 + Number.EPSILON);
        var sum = Math.round(n) / p;
        return sum.toFixed(2)
    }

    const onRowClick = (data, col, id) => {
        setWHRow1(id);
        setcol2(false);
        if (col === 1) {
            listitem[id].Invoicedate = parm[0]
            if (!data.PayableCode) {
                listitem[id].PayableCode = parm[1]
                listitem[id].PayableName = parm[2]
            }
            listitem[id].TaxPersen = parm[3]
        }
        if (data.Taxinvoice) {
            setcol2(true);
            if (col === 3) {
                data.btn_C3 = 1
            }
        } else {
            data.btn_C3 = 0
        }
        Refundablerate.current.value = listitem[id].Refundablerate ? listitem[id].Refundablerate : (0.00).toFixed(2)
        Refundablevalue.current.value = listitem[id].Refundablevalue ? listitem[id].Refundablevalue : (0.00).toFixed(2)
        Taxrefund.current.value = listitem[id].Refundabletax ? listitem[id].Refundabletax : (0.00).toFixed(2)
    }
    const onAfterSaveCell = async (row, cellName, cellValue) => {
        var Taxinvoices = 0
        var l = 0
        for (let i = 0; i < listitem.length; i++) {
            if (listitem[i].Taxinvoice === cellValue) {
                Taxinvoices = l
                l++
            }
        }
        if (cellName === "Taxinvoice" && row.Taxinvoice !== "" && row.Taxinvoice !== undefined) {
            var url = "CSINPUTTAX/Checkcountitem?DOCNO=" + row.Taxinvoice
            //   console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
                if (res.data.length > 0) {
                    if (res.data[0].countitem === 0 && Taxinvoices < 1) {
                        row.Taxinvoice = await cellValue
                    } else {
                        row.Taxinvoice = ""
                        setopensnackbar(true)
                        setcolor("warning")
                        setmessagealert("เลขที่ใบกำกับภาษีซ้ำ")
                    }
                } else {
                    row.Taxinvoice = ""
                    setopensnackbar(true)
                    setcolor("warning")
                    setmessagealert("network error")
                }
            })
        }
        if (row.Taxinvoice) {
            if (cellName === 'Amountbeforetax') {
                let res = Number(listitem[WHRow1].TaxPersen / 100) * Number(cellValue)
                listitem[WHRow1].Tax = parseFloat(res).toFixed(2)
            }
            if (cellName === 'Taxincluded') {
                let res = (Number(cellValue) / (100 + Number(listitem[WHRow1].TaxPersen))) * Number(listitem[WHRow1].TaxPersen)
                // console.log(listitem[WHRow1].TaxPersen);
                listitem[WHRow1].Tax = parseFloat(res).toFixed(2)
            }
            listitem[WHRow1].Refundablerate = Refundablerate.current.value
            listitem[WHRow1].Refundablevalue = Refundablerate.current.value
            listitem[WHRow1].Refundabletax = Refundablerate.current.value
            setTimeout(() => {
                SumCalculate(cellName)
            }, 30);
        }
        setTimeout(() => {
            ReLoadData()
        }, 50);

    }
    const ReLoadData = () => {
        var col = listitem
        var NewCol = []
        var j = 0
        for (let i = 0; i < col.length; i++) {
            if (col[i].Taxinvoice) {
                NewCol[j] = col[i]
                j++
            }
        }
        for (let i = j; i < col.length; i++) {

            NewCol[j] = {
                Taxinvoice: "",
                Invoicedate: "",
                PayableCode: "",
                PayableName: "",
                Taxdescription: "",
                Amountbeforetax: "",
                TaxPersen: "",
                Taxincluded: "",
                Tax: "",
                Refundablerate: "",
                Refundablevalue: "",
                Refundabletax: "",
            }
            j++
        }
        setListitem(NewCol)
        // sendData(true)
    }
    const onBeforeSaveCell = (row, cellName, cellValue) => {
    }
    const SumCalculate = async (cellName) => {
        let sumTax = 0
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice !== "") {
                if (cellName === 'Amountbeforetax') {
                    let sum = Number(listitem[index].Amountbeforetax !== "" ? listitem[index].Amountbeforetax : 0) + Number(listitem[index].Tax !== "" ? listitem[index].Tax : 0)
                    listitem[index].Taxincluded = parseFloat(sum).toFixed(2)
                }
                if (cellName === 'Taxincluded') {
                    listitem[index].Amountbeforetax = await Number(listitem[index].Taxincluded !== "" ? listitem[index].Taxincluded : 0) - Number(listitem[index].Tax !== "" ? listitem[index].Tax : 0)
                }
                if (listitem[index].Tax !== "") {
                    sumTax += Number(listitem[index].Tax)
                }
            }
        }
        setListitem(listitem)
        if (sumTax > 0) {
            Totaltax.current.value = parseFloat(sumTax).toFixed(2)
        }
    }
    const caltax = () => {
        // console.log("caltax", listitem);
        let sumTax = 0
        for (let index = 0; index < listitem.length; index++) {
            if (listitem[index].Taxinvoice !== "") {
                if (listitem[index].Tax !== "") {
                    sumTax += Number(listitem[index].Tax)
                    //  console.log("sumTax", sumTax);
                }
            }
        }
        if (sumTax > 0) {
            Totaltax.current.value = parseFloat(sumTax).toFixed(2)
        }
    }
    const sendData = (e) => {
        let chktable = false
        for (let i = 0; i < listitem.length; i++) {
            if (listitem[i].Taxinvoice) {
                chktable = true
                if (!listitem[i].Amountbeforetax || Number(listitem[i].Amountbeforetax) <= 0) {
                    setopensnackbar(true)
                    setcolor("warning")
                    setmessagealert("กรุณากรอกยอดก่อนภาษีด้วยครับ")
                    return
                }
            }
        }
        if (!chktable) {
            setopensnackbar(true)
            setcolor("warning")
            setmessagealert("กรุณากรอกข้อมูลในตารางด้วยครับ")
            return
        }
        let resdata = []
        resdata.push(e)
        resdata.push(listitem)
        resdata.push(Refundablerate.current.value)
        resdata.push(Refundablevalue.current.value)
        resdata.push(Taxrefund.current.value)
        resdata.push(Totaltax.current.value)
        props.resdata(resdata)
    }
    const Get_PopupApcode = (data1, data2) => {
        listitem[WHRow1].PayableCode = data1
        listitem[WHRow1].PayableName = data2
    }
    const onBlurAction = (e) => {
        if (e.target.type === "number") {
            e.target.value = e.target.value ? parseFloat(e.target.value).toFixed(2) : parseFloat(0).toFixed(2)
        }
        if (e.target.name === "Refundablerate") {
            average()
        }
    }
    const onclick = (e) => {
        if (e.target.type === "number") {
            e.target.value = Number(e.target.value); e.target.select()
        }
    }
    const onkeydown = (e) => {
        if (e.target.name === "Refundablerate" && e.key === 'Enter') {
            average()
        }
    }
    const average = () => {
        if (WHRow1 !== "") {
            let Taxnumber = (listitem[WHRow1].Tax ? parseFloat(listitem[WHRow1].Tax) : 0) / 100
            let sum = Taxnumber * Number(Refundablerate.current.value)
            let decimal = round(sum, 2)
            Refundablevalue.current.value = round(((sum * 100) / 7), 2)
            Taxrefund.current.value = decimal
            listitem[WHRow1].Refundablerate = Refundablerate.current.value
            listitem[WHRow1].Refundablevalue = round(((sum * 100) / 7), 2)
            listitem[WHRow1].Refundabletax = round(sum, 2)
        } else {
            Refundablerate.current.value = (0).toFixed(2)
            Refundablevalue.current.value = (0).toFixed(2)
            Taxrefund.current.value = parseFloat(0).toFixed(2)
        }
    }
    function _cellButton2(cell, row) {
        var btn = row.btn_C3;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} onClick={() => setSwitchPopupApcode(true)} >
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case 2:
                btnShow = <i className=""></i>;
                break;
        }
        return (<div>{btnShow}</div>);
    }
    const indexN = (cell, row, enumObject, index) => {
        return (<div>{index + 1}</div>)
    }
    return (
        <div className="panel-body DivTable" onBlur={e => onBlurAction(e)} onClick={e => onclick(e)} onKeyDown={onkeydown}>
            {SwitchPopupApcode ? <PopupApcode closePopup={() => { setSwitchPopupApcode(false) }} Get_PopupApcode={Get_PopupApcode} /> : null}
            <BootstrapTable
                data={listitem}
                options={{
                    onRowClick: onRowClick,
                    //noDataText: "ไม่พบข้อมูล"
                }}
                height='650'
                cellEdit={{ //แก้ไข
                    mode: 'click',
                    blurToSave: true,
                    beforeSaveCell: onBeforeSaveCell,
                    afterSaveCell: onAfterSaveCell,
                }} >
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField="any" dataFormat={indexN} isKey> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="100" dataField='Taxinvoice' editable={true} ><div align="center"> ใบกำกับภาษี </div> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='Invoicedate'><div align="center"> วันที่ใบกำกับ </div>  </TableHeaderColumn>
                <TableHeaderColumn row="0" colSpan="2" dataAlign="center" columnClassName="columnAll" className="columnNumber" /* className="colbuttomhidden" */ width="170"> <div align="center"> รหัสเจ้าหนี้ </div> </TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="PayableCode" editable={col2} dataAlign="center" width="140"></TableHeaderColumn>
                <TableHeaderColumn row="1" dataField="btn_C3" editable={false} dataAlign="center" width="30" dataFormat={_cellButton2} columnClassName="columnClassNameFormat1"></TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='PayableName' editable={col2} ><div align="center"> ชื่อผู้ขาย / ผู้ให้บริการ  </div> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='Taxdescription'><div align="center"> คำอธิบายภาษี </div>  </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='Amountbeforetax'><div align="center"> ยอดก่อนภาษี </div>  </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='Tax' editable={false}><div align="center"> ภาษี </div> </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='Taxincluded' ><div align="center"> รวมภาษี </div>  </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataField='TaxPersen' hidden > TaxPersen </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataField='Refundablerate' hidden > อัตราขอคืนได้ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataField='Refundablevalue' hidden  > มูลค่าที่ขอคืนได้ </TableHeaderColumn>
                <TableHeaderColumn row="0" rowSpan="2" dataField='Refundabletax' hidden > ภาษีที่ขอคืนได้ </TableHeaderColumn>
            </BootstrapTable>
            <div>
                <br></br>
                <Grid>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">อัตราขอคืนได้ </span>
                                            <input type="number" className="form-control" ref={Refundablerate} name="Refundablerate" id='Refundablerate' />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="show-grid">
                            <Col xs={12} sm={4} md={4} lg={4}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <Button variant="outlined" size="small" onClick={() => average()}>เฉลี่ย</Button>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row className="show-grid">

                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">มูลค่าที่ขอคืนได้  </span>
                                            <input type="number" className="form-control" ref={Refundablevalue} name="Refundablevalue" />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">ภาษีที่ขอคืนได้  </span>
                                            <input type="number" className="form-control" ref={Taxrefund} name="Taxrefund" />
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={4} sm={12} md={4} lg={4}>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รวมยอดภาษี  </span>
                                            <input type="number" className="form-control" ref={Totaltax} name="Totaltax" />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <Button variant="outlined" size="small" onClick={() => sendData(false)}> ตกลง </Button>
                                        </div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
                <Snackbar place="br"
                    color={color}
                    icon={icon}
                    autoClose={autoClose}
                    message={messagealert}
                    open={opensnackbar}
                    closeNotification={() => { setopensnackbar(false) }}
                    close />
            </div>
        </div>)
}

Inputtax.prototype = {
    parm: PropTypes.array
}